<template>
  <div class="text-xs-center">
    <v-layout row justify-center>
      <v-snackbar v-model="values.dialog" :color="values.color || 'info'" 
      :timeout="values.timeout || 6000" right top>
        {{ values.text || ''}}
        <v-btn outline round color="white" to="/upgrade">{{this.translate('system.button.upgrade.title')}}</v-btn>
        <v-btn dark flat @click="$store.commit('snackbarPlan/change_values', {dialog: false})">
          <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </div>

</template>

<script>
  export default {
    name: 'snackbarPlan',
    computed: {
      values () {
        return this.$store.getters[`snackbarPlan/values`] || ''
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PSnackbarPlan.vue